export default {"src":"/_next/static/media/WhoWeAre_021A.854f7c2b.JPG","height":712,"width":1920};